import * as React from "react";
import styled from "../../../styled/index";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { ModalContent, ModalTitle } from "./content";
const Wrapper = styled("div") `
  .content {
    border-bottom: 1px solid ${(props) => props.theme.box.border};
  }
`;
const Icon = styled("div") `
  font-size: 16px;
`;
export class ModalDropContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { active: props.autoOpen || false };
        this.toggle = this.toggle.bind(this);
    }
    toggle() {
        const active = !this.state.active;
        this.setState({ active });
        if (this.props.onDrop) {
            this.props.onDrop(active);
        }
    }
    render() {
        const { active } = this.state;
        const props = this.props;
        return (React.createElement(Wrapper, null,
            React.createElement(ModalTitle, { className: "cursor", level: props.level, onClick: this.toggle, paddinglr: props.paddinglr, paddingtb: props.paddingtb },
                props.title,
                React.createElement(Icon, null, active ? React.createElement(FaChevronUp, null) : React.createElement(FaChevronDown, null))),
            active && (React.createElement(ModalContent, { className: "content", paddinglr: props.cPaddinglr, paddingtb: props.cPaddingtb }, props.children))));
    }
}
//# sourceMappingURL=drop-content.js.map